export default __webpack_public_path__ + "static/media/higher-mathematics.da173877.svg";